// Angular Core
import { Location } from "@angular/common";
import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  NgForm,
  ValidationErrors,
  ValidatorFn,
  Validators
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { forkJoin, Observable, Subscription, tap } from "rxjs";
// Angular Material
import { MatDialog } from "@angular/material/dialog";
import { MatStepper } from "@angular/material/stepper";
// Services
import { PartnerService } from "src/app/share/service/partner.service";
import { MasterDataDataService } from "../../../share/data-service/master-data.data.service";
import {
  CheckDuplicateRequest,
  CheckDuplicateResponse,
  MotorQuotationDataService
} from "../../../share/data-service/motor/motor-quotation.data.service";
import { AlertService } from "../../../share/service/alert.service";
// Interfaces
import { DropdownItem } from "../../../share/interface/common.interface";
import { MotorQuotationInterface } from "../../../share/interface/motor-quotation.interface";
// Components
import { SubmitFailDialogComponent } from "src/app/dashboard/submit-fail-dialog/submit-fail-dialog.component";
import { SubmitSuccessDialogComponent } from "src/app/dashboard/submit-success-dialog/submit-success-dialog.component";
// Utilities
import { Overlay } from "@angular/cdk/overlay";
import { TranslateService } from "@ngx-translate/core";
import { GoogleTagManagerService } from "angular-google-tag-manager";
import * as moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { RequestStatusDialogComponent } from "src/app/d2c/ui/request-status-dialog/request-status-dialog.component";
import { BeforeExpiredDialogComponent } from "src/app/share/component/before-expired-dialog/before-expired-dialog.component";
import { SubmitSuccessAvDialogComponent } from "src/app/share/component/submit-success-av-dialog/submit-success-av-dialog.component";
import { GrabMiniappDialogComponent } from "src/app/dashboard/grab-miniapp-dialog/grab-miniapp-dialog.component";
import {
  INSURED_TYPE,
  TYPE_OF_DRIVE,
  VEHICLE_TYPE
} from "src/app/share/constants/common.types";
import { MotorDataDataService } from "src/app/share/data-service/motor.data.service";
import { FileService } from "src/app/share/service/file.service";
import { PartnerDataService } from "src/app/share/service/partnerData.service";
import SwiperCore, {
  Autoplay,
  Navigation,
  Pagination,
  SwiperOptions
} from "swiper";
import { SwiperComponent } from "swiper/angular";
import { ValidatorFunction } from "../../../share/function/validator.function";
import { IAvailableBanners, SubmitQuotationResponseInterface } from "src/app/share/interface/motor.interface";
import { IPartnerIDType } from "src/app/share/interface/partner.interface";
import { CommonFunction } from "src/app/share/function/common.function";
import { AuthenticateGrabIDClientService } from '../../../share/service/authenticateGrabIDClient.service';
import { ContainerModule, ContainerAnalyticsEventState, ContainerAnalyticsEventName } from '@grabjs/superapp-sdk';
import { Buffer } from 'buffer';

SwiperCore.use([Pagination, Autoplay, Navigation]);
@Component({
  selector: "app-affiliates-landing",
  templateUrl: "./affiliates-landing.component.html",
  styleUrls: ["./affiliates-landing.component.scss"]
})
export class AffiliateslandingComponent implements OnInit, OnDestroy {
  @ViewChild("stepper") stepper: MatStepper;
  @ViewChild("swiper", { static: true }) swiper: SwiperComponent;
  swiperOptions: SwiperOptions = {
    slidesPerView: 1,
    slidesPerGroup: 1,
    grabCursor: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    pagination: {
      clickable: true
    }
  };

  partnerCode: string;
  bannerView: boolean = true;
  // partnerBannerViewList = [
  //   "carsome",
  //   "wapcar",
  //   "carlist",
  //   "grab",
  //   "ktmb",
  //   "foodpanda",
  //   "lalamove"
  // ];

  @ViewChild("vehicleForm") vehicleForm: NgForm;
  @ViewChild("custForm") custForm: NgForm;
  vehicleFormGroup: FormGroup;
  custFormGroup: FormGroup;
  docFormGroup: FormGroup;

  countryList: string[] = [];
  filterCountryList: string[] = [];

  isCompany: boolean = false;
  isMalaysian: boolean = true;
  pdpaAgreement: boolean = false;
  mobileView: boolean = false;
  isCar: boolean = true;
  isLorry: boolean = false;
  isMotorcycle: boolean = false;

  ehailingBanners: Banner[];
  loadedBanners: number = 0;
  loadedEhailingBanners: number = 0;

  utmCampaign: string;
  utmSource: string;
  utmMedium: string;
  utmContent: string;
  mmRef: string | null;
  maxDob: Date = new Date();
  contactInfo: string;
  successGifType: string;

  quotationSubmitted: boolean = false;
  quotationInputData: MotorQuotationInterface;
  quotationFormData: any;
  validPostcodes: string[] = [];
  mileagePlans: DropdownItem[] = [];

  idTypeList: IPartnerIDType[] = [];
  filteredIdTypeList: IPartnerIDType[] = [];
  private idTypeEhailingFilter: boolean = false;

  typeOfInsuranceList = [
    { id: "TPFT", name: "common.TPFT" },
    { id: "COM", name: "common.COM" }
  ];

  vehicleTypeList = [];

  showWhatsappBtn: Boolean = false;
  showVehicleTypeRadios: Boolean = false;
  showMileagePlans: Boolean = false;
  showEHailingOption: Boolean = false;

  showAgreeOrMarketValueBtn: Boolean = false;
  hideTPDesc: Boolean = false;
  hideTPFTDesc: Boolean = false;

  typeOfSumOption = INSURED_TYPE;

  carGrant: any;
  acceptFile: string = ".pdf,.png,.jpg,.jpeg";
  maxLength: number = 1; // Maximum number of files
  fileSize: number = 10; // Maximum file size
  fileList: File[] | any = [];

  subscriptions: Subscription[] = [];
  availableBanners: IAvailableBanners[] = [];

  takafulVer: string = "";
  takafulVerPartnerList = ["prolindung"];

  containerModule: any = new ContainerModule();
  isGrabMiniApp: Boolean = false;

  constructor(
    gtmService: GoogleTagManagerService,
    public partnerData: PartnerDataService,
    public translate: TranslateService,
    public overlay: Overlay,
    private formBuilder: FormBuilder,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private ngxSpinnerService: NgxSpinnerService,
    private alertService: AlertService,
    private partnerService: PartnerService,
    private masterDataDataService: MasterDataDataService,
    private motorDataDataService: MotorDataDataService,
    private motorQuotationDataService: MotorQuotationDataService,
    private partnerDataService: PartnerDataService,
    private fileService: FileService,
    private authenticateGrabIDClientService: AuthenticateGrabIDClientService
  ) {
    gtmService.pushTag({
      event: "car_lp"
    });
    this.getParams();
    this.initForm();
    this.listenChanges();
    this.takafulVer = this.takafulVerPartnerList.includes(this.partnerCode) ? "_ver2" : this.takafulVer;
  }

  ngOnInit(): void {
    if (window.screen.width < 960) {
      this.mobileView = true;
    }

    if (
      this.showMileagePlans ||
      this.partnerDataService?.partnerDetail?.isMileageEnabled
    ) {
      this.vehicleFormGroup
        .get("mileagePlan")
        .setValidators([Validators.required]);
      this.vehicleFormGroup.get("mileagePlan").updateValueAndValidity();
    }

    if (this.partnerCode === "ktmb") {
      this.vehicleFormGroup.get("insuranceType").disable();
    }
    // if (
    //   this.partnerCode === "grab" &&
    //   this.vehicleFormGroup.value.typeOfDrive == "Regular"
    // ) {
    //   this.typeOfInsuranceList = [
    //     { id: "COM", name: "common.COM" },
    //     { id: "TPFT", name: "common.TPFT" }
    //   ];
    // }
    // if (this.partnerCode === "carsome") {
    //   this.idTypeList.push(
    //     { id: 4, description: "common.commercialInd", seq: 4 },
    //     { id: 5, description: "common.commercialComp", seq: 5 }
    //   );
    // }

    this.getVehicleTypeAccess();
    this.setMalaysian();
    this.getAvailableBanners();
  }

  ehailingSelectedChange(event) {
    // if (this.partnerCode === "grab" && event.value == TYPE_OF_DRIVE.regular) {
    //   this.typeOfInsuranceList = [
    //     { id: "COM", name: "common.COM" },
    //     { id: "TPFT", name: "common.TPFT" }
    //   ];
    // } else if (this.partnerCode === "grab" && event.value == "Ehailing") {
    //   this.typeOfInsuranceList = [{ id: "COM", name: "common.COM" }];
    // }

    // if (
    //   this.partnerCode === "lalamove" &&
    //   event.value == "Ehailing" &&
    //   this.isCar
    // ) {
    //   this.allInsuranceTypeList = [{ id: "COM", name: "common.COM" }];
    //   this.vehicleFormGroup.controls.eHailingUsed.setValue(true);

    //   this.hideTPFTDesc = true;
    //   this.hideTPDesc = true;
    // } else if (
    //   this.partnerCode === "lalamove" &&
    //   event.value == "Regular" &&
    //   this.isCar
    // ) {
    //   this.allInsuranceTypeList = [
    //     { id: "COM", name: "common.COM" },
    //     { id: "TPFT", name: "common.TPFT" },
    //     { id: "TP", name: "common.TP" }
    //   ];
    //   this.vehicleFormGroup.controls.eHailingUsed.setValue(false);
    // }
    if (!event.value) {
      this.filterIdTypeList(false);
      this.typeOfInsuranceList = this.parseInsuranceTypes(
        this.partnerDataService?.partnerDetail.insuranceType
      );
    }

    if (event.value) {
      this.filterIdTypeList(true);

      this.typeOfInsuranceList = this.parseInsuranceTypes(
        this.partnerDataService?.partnerDetail.insuranceTypeEhailing
      );
    }
  }

  filterIdTypeList(ehailingUsed: boolean): void {
    this.idTypeEhailingFilter = ehailingUsed;

    // Commercial (Individual / Company) is C Permit, which is not available for TP
    const isTp = this.vehicleFormGroup?.get("insuranceType")?.value === "TP";

    this.filteredIdTypeList = this.idTypeList.filter(
      (item) =>
        item.isEhailing === ehailingUsed && !(isTp && [4, 5].includes(item.seq))
    );
  }

  updateResetFlag(value: any): void {
    if (!value) return;

    let insuranceType = value.data.isTpftVehicleOverage
      ? this.typeOfInsuranceList[0].id
      : this.typeOfInsuranceList[1].id;

    this.vehicleFormGroup.get("insuranceType")!.patchValue(insuranceType);

    this.quotationSubmitted = false;
  }

  getIdTypeList() {
    this.partnerService
      .getPartnerIdentityTypeByCode(this.partnerCode)
      .subscribe({
        next: (x: IPartnerIDType[]) => {
          this.idTypeList = x;
          this.filterIdTypeList(false);

          this.custFormGroup.patchValue({
            idType: this.idTypeList[0]?.seq
          });
        }
      });
  }

  private async getParams(): Promise<void> {
    let snapshotParam = this.activatedRoute.snapshot.queryParams;
    let paramsPartnerCode = snapshotParam.partnerCode;
    let lang: string = snapshotParam.lang;
    let referrer = document.referrer;

    this.partnerCode = await this.partnerService.getPartnerCode();

    if (this.partnerCode) {
      await this.partnerDataService.getPartnerDetail(this.partnerCode);

      this.fetchMasterData();
      this.getIdTypeList();

      if (this.partnerCode == "grabc") {
        const { status_code } = await this.containerModule.isConnected();

        if (status_code === 200) {
          this.isGrabMiniApp = true;

          await this.containerModule.sendAnalyticsEvent({
            state: ContainerAnalyticsEventState.HOMEPAGE,
            name: ContainerAnalyticsEventName.DEFAULT
          });

          await this.authenticateGrabIDClientService.startAuthentication();

          if (!referrer.includes('/payment/response'))
          {
            await this.containerModule.getSessionParams().then(({ result, error }) => {
              if (result) {
                const sessionParams = Buffer.from(result, 'base64').toString('utf-8');
                const sessionParamsObj = JSON.parse(sessionParams);

                if (sessionParamsObj.linkId) {
                  window.location.href = `/comparison/${sessionParamsObj.linkId}`;
                }
              }
            });
          }
        }
        else {
          let dialogRef = this.dialog.open(GrabMiniappDialogComponent, {
            panelClass: "",
            disableClose: true,
            autoFocus: false,
            data: { redirectUrl: window.location.href }
          });
        }
      }
    }

    if (this.partnerDataService?.partnerDetail?.enableWhatsapp) {
      this.showWhatsappBtn = true;
    }

    if (this.partnerDataService?.partnerDetail?.isMileageEnabled) {
      this.showMileagePlans = true;
    }

    // if (this.partnerBannerViewList.includes(this.partnerCode)) {
    //   this.bannerView = true;
    // }

    if (this.partnerDataService?.partnerDetail?.isTypeOfSumEnabled) {
      this.showAgreeOrMarketValueBtn = true;
    }

    if (this.partnerDataService?.partnerDetail?.isEhailingEnabled) {
      this.showEHailingOption = true;
    }
    if (this.partnerDataService?.partnerDetail?.insuranceType) {
      this.typeOfInsuranceList = this.parseInsuranceTypes(
        this.partnerDataService?.partnerDetail.insuranceType
      );
    }

    if (this.partnerDataService?.partnerDetail?.vehicleTypeAccess) {
      const types = this.partnerDataService?.partnerDetail?.vehicleTypeAccess
        .split(",")
        .map((x) => x.trim());
      this.showVehicleTypeRadios = types.length > 1;
    } else {
      this.showVehicleTypeRadios = false;
    }

    !this.partnerCode ? (window.location.href = "/") : null;

    if (lang) this.translate.use(lang);
    this.utmSource = (this.isGrabMiniApp) ? "GrabMiniApp" : snapshotParam.utm_source;
    this.utmMedium = snapshotParam.utm_medium;
    this.utmCampaign = snapshotParam.utm_campaign;
    this.utmContent = snapshotParam.utm_content;
    this.mmRef = this.partnerService.mmRef;

    if (!this.utmSource) {
      let searchEngineList = ["google", "yahoo", "bing"];
      let referrer = document.referrer;
      if (
        referrer != window.location.href ||
        referrer.includes("policystreet.com")
      ) {
        let searchEngine = searchEngineList.find((x) =>
          referrer.toLowerCase().includes(x)
        );
        if (searchEngine) {
          this.utmSource = searchEngine;
          this.utmMedium = "organic";
        } else {
          if (!referrer) this.utmSource = "direct";
          else {
            let url = new URL(referrer);
            this.utmSource = url.hostname;
            this.utmMedium = "referral";
          }
        }
      } else {
        this.utmSource = "direct";
      }
    }

    // if coming from affiliates with domain names, remove route name
    if (!paramsPartnerCode) {
      this.removeUrlRouteName();
    }
  }

  private parseInsuranceTypes(
    value: string | null | undefined
  ): { id: string; name: string }[] {
    if (!value) return [];
    return value
      .split(",")
      .map((type) => type.trim())
      .filter((type) => !!type)
      .map((type) => ({ id: type, name: `common.${type}` }));
  }

  private getVehicleTypeAccess(): void {
    this.motorDataDataService.getVehicleTypeAccess().subscribe({
      next: (x) => {
        let type = VEHICLE_TYPE.car;

        if (!x.includes(",")) {
          switch (x) {
            case VEHICLE_TYPE.motorcycle:
              this.isMotorcycle = true;
              this.isLorry = false;
              this.isCar = false;
              type = VEHICLE_TYPE.motorcycle;
              break;
            case VEHICLE_TYPE.lorry:
              this.isLorry = true;
              this.isCar = false;
              this.isMotorcycle = false;
              type = VEHICLE_TYPE.lorry;
              break;
            default:
              this.isLorry = false;
              this.isCar = true;
              this.isMotorcycle = false;
              break;
          }
          this.vehicleFormGroup?.get("vehicleType")?.setValue(type);
        } else {
          this.vehicleTypeList = x.split(",");
        }

        this.updateFormValidation();
      },
      error: (err) => {
        this.alertService.openSnackBar(err.error);
      }
    });
  }

  private getAvailableBanners(): void {
    this.motorDataDataService.getAvailableBanners().subscribe({
      next: (x: IAvailableBanners[]) => {
        this.availableBanners = x.filter(
          (banner) =>
            banner.status === "Active" &&
            (banner.refType?.includes("desktop_square") ||
              banner.refType?.includes("mobile_square"))
        );
      },
      error: () => {
        console.log("Failed to retrieve available campaigns.");
      }
    });
  }

  // The plate format check only applies to cars; motorcycle and lorry plates
  // keep the required check alone.
  private getCarPlateValidators(): ValidatorFn[] {
    return this.isCar
      ? [Validators.required, ValidatorFunction.carPlateNoValidator]
      : [Validators.required];
  }

  private updateFormValidation(): void {
    if (this.vehicleFormGroup) {
      const identityNoControl = this.vehicleFormGroup.get("identityNo");
      const insuranceTypeControl = this.vehicleFormGroup.get("insuranceType");
      const carPlateControl = this.vehicleFormGroup.get("carPlate");

      carPlateControl?.setValidators(this.getCarPlateValidators());
      carPlateControl?.updateValueAndValidity();

      if (this.isMotorcycle) {
        identityNoControl?.setValidators(Validators.required);
        insuranceTypeControl?.setValue("COM");
        insuranceTypeControl?.clearValidators();
      } else {
        identityNoControl?.clearValidators();
        insuranceTypeControl?.setValidators(Validators.required);
      }

      identityNoControl?.updateValueAndValidity();
      insuranceTypeControl?.updateValueAndValidity();
    }

    if (this.custFormGroup) {
      const idTypeControl = this.custFormGroup.get("idType");
      const identityNoControl = this.custFormGroup.get("identityNo");
      const nationalityControl = this.custFormGroup.get("nationality");

      if (this.isMotorcycle) {
        idTypeControl?.setValue(null);
        idTypeControl?.clearValidators();

        identityNoControl?.clearValidators();
        nationalityControl?.clearValidators();
      } else {
        idTypeControl?.setValue(this.idTypeList[0]?.seq ?? null);
        idTypeControl?.clearValidators();

        identityNoControl?.setValidators(Validators.required);
        nationalityControl?.setValidators(Validators.required);
      }

      idTypeControl?.updateValueAndValidity();
      identityNoControl?.updateValueAndValidity();
      nationalityControl?.updateValueAndValidity();
    }
  }

  private initForm(): void {
    this.vehicleFormGroup = this.formBuilder.group({
      insuranceType: this.isMotorcycle ? ["COM"] : ["COM", Validators.required],
      carPlate: [null, this.getCarPlateValidators()],
      postcode: [
        null,
        [
          Validators.required,
          (control: FormControl) => this.postcodeValidator(control)
        ]
      ],
      identityNo: this.isMotorcycle ? [null, Validators.required] : [null],
      insuredType: this.showAgreeOrMarketValueBtn
        ? ["MV", Validators.required]
        : ["MV"],
      includeRoadTax: [false],
      eHailingUsed: [false],
      mileagePlan: [null],
      vehicleType: "Car",
      typeOfDrive: "Regular",
      isReconVehicle: [false]
    });

    this.custFormGroup = this.formBuilder.group({
      idType: this.isMotorcycle ? [null] : [this.idTypeList[0]?.seq],
      identityNo: this.isMotorcycle ? [null] : [null, Validators.required],
      oldBizRegNo: [null],
      tINGovInd: [false],
      tINNo: [],
      sSTRegNo: [],
      name: [
        null,
        [Validators.required, ValidatorFunction.nameValidator]
      ],
      policIdentityNo: [null],
      nationality: this.isMotorcycle ? [null] : [null, Validators.required],
      dob: [null],
      gender: [null],
      maritalStatus: ["Single", Validators.required],
      contactMethod: ["Email"],
      mobileNo: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]]
    });

    this.docFormGroup = this.formBuilder.group({});
  }

  /**
   * NOTE: Add valueChanges inside subscription block
   * REASON: Ensure all event listeners are cleaned up when component destroyed
   * Purpose: Prevent memory leaks and logic running when component destroyed
   */
  listenChanges(): void {
    this.vehicleFormGroup
      .get("vehicleType")
      ?.valueChanges.subscribe((value) => {
        this.isCar = value === VEHICLE_TYPE.car;
        this.isLorry = value === VEHICLE_TYPE.lorry;
        this.isMotorcycle = value === VEHICLE_TYPE.motorcycle;
        this.updateFormValidation();

        if (value == VEHICLE_TYPE.lorry) {
          this.typeOfInsuranceList = this.parseInsuranceTypes(
            this.partnerDataService?.partnerDetail?.insuranceTypeLorry
          );
        } else if (value == VEHICLE_TYPE.car) {
          this.typeOfInsuranceList = this.parseInsuranceTypes(
            this.partnerDataService?.partnerDetail?.insuranceType
          );
        } else if (value == VEHICLE_TYPE.motorcycle) {
          this.typeOfInsuranceList = this.parseInsuranceTypes(
            this.partnerDataService?.partnerDetail?.insuranceType
          );
        }
      });

    this.subscriptions.push(
      this.vehicleFormGroup
        .get("identityNo")
        .valueChanges.subscribe((value) => {
          if (this.vehicleFormGroup.get("identityNo").invalid) {
            ["dob", "gender"].forEach((key) => {
              this.custFormGroup.get(key).reset();
            });
          } else {
            this.getGenderAndDate(value);
          }
        })
    );

    this.subscriptions.push(
      this.custFormGroup.get("identityNo").valueChanges.subscribe((value) => {
        if (this.custFormGroup.get("identityNo").invalid) {
          ["dob", "gender"].forEach((key) => {
            this.custFormGroup.get(key).reset();
          });
        }

        if (
          this.custFormGroup.get("identityNo").valid &&
          this.isMalaysian &&
          !this.isCompany
        ) {
          this.getGenderAndDate(value);
        }
      }),

      this.custFormGroup.get("idType").valueChanges.subscribe((value) => {
        switch (value) {
          case 1:
          case 4:
            this.setMalaysian();
            break;

          case 2:
            this.setNonMalaysian();
            break;

          case 3:
          case 5:
            this.setIsCompany();
            break;
        }

        // Reset Vehicle Grant if selection out from commercial option
        if ([1, 2, 3].includes(value)) {
          this.carGrant = null;
        }
      }),

      this.vehicleFormGroup
        .get("insuranceType")
        .valueChanges.subscribe((value) => {
          // Refresh the ID Type list: TP hides Commercial (C Permit)
          this.filterIdTypeList(this.idTypeEhailingFilter);

          const idType = this.custFormGroup.get("idType");
          if (value === "TP" && [4, 5].includes(idType.value)) {
            idType.patchValue(this.idTypeList[0]?.seq);
          }

          if (value === "COM") return;
          this.vehicleFormGroup.get("eHailingUsed").patchValue(false);
        }),

      // On Ehailing Used Changed
      this.vehicleFormGroup
        .get("eHailingUsed")
        .valueChanges.subscribe((value) => {
          if (this.partnerCode !== "carsome") return;

          const idType = this.custFormGroup.get("idType");

          // if (value) {
          //   this.idTypeList.splice(3);

          //   if ([4, 5].includes(idType.value)) {
          //     idType.patchValue(this.idTypeList[0].seq);
          //   }
          // } else {
          //   // Stop pushing commercial options if already existed
          //   if (this.idTypeList.length === 5) return;

          //   this.idTypeList.push(
          //     { id: 4, description: "common.commercialInd", seq: 4 },
          //     { id: 5, description: "common.commercialComp", seq: 5 }
          //   );
          // }
        })
    );
  }

  private setMalaysian(): void {
    this.isCompany = false;
    this.isMalaysian = true;

    if (this.isMotorcycle) {
      this.vehicleFormGroup
        .get("identityNo")
        .setValidators([
          Validators.required,
          ValidatorFunction.nricValidator()
        ]);

      ["identityNo"].forEach((key) => {
        this.vehicleFormGroup.get(key).updateValueAndValidity();
      });
    } else {
      this.vehicleFormGroup.get("identityNo").clearValidators();
      ["identityNo"].forEach((key) => {
        this.vehicleFormGroup.get(key).updateValueAndValidity();
      });

      this.custFormGroup
        .get("identityNo")
        .setValidators([
          Validators.required,
          ValidatorFunction.nricValidator()
        ]);
      this.custFormGroup.get("nationality").clearValidators();

      ["identityNo", "nationality"].forEach((key) => {
        this.custFormGroup.get(key).updateValueAndValidity();
      });
    }

    ["dob", "gender"].forEach((key) => {
      this.custFormGroup.get(key).disable();
    });

    this.custFormGroup
      .get("name")
      .setValidators([Validators.required, ValidatorFunction.nameValidator]);
    this.custFormGroup.get("name").updateValueAndValidity();

    this.setNonCompanyValidation();
  }

  private setNonMalaysian(): void {
    this.isCompany = false;
    this.isMalaysian = false;

    this.getCountryList();

    ["dob", "gender"].forEach((key) => {
      this.custFormGroup.get(key).enable();
    });

    ["identityNo", "nationality"].forEach((key) => {
      this.custFormGroup.get(key).setValidators(Validators.required);
      this.custFormGroup.get(key).updateValueAndValidity();
    });

    this.custFormGroup
      .get("name")
      .setValidators([Validators.required, ValidatorFunction.nameValidator]);
    this.custFormGroup.get("name").updateValueAndValidity();

    this.setNonCompanyValidation();
  }

  private setIsCompany(): void {
    this.isCompany = true;
    this.isMalaysian = true;

    this.custFormGroup.get("identityNo").setValidators([Validators.required]);
    // Company names legitimately contain digits/symbols (e.g. "Sdn. Bhd."),
    // so the letters-and-spaces-only nameValidator only applies to individual name entry.
    this.custFormGroup.get("name").setValidators(Validators.required);

    ["identityNo", "name"].forEach((key) => {
      this.custFormGroup.get(key).updateValueAndValidity();
    });

    this.setCompanyValidation();
  }

  private postcodeValidator(control: FormControl): ValidationErrors | null {
    if (control.value === null || control.value.length !== 5) return null;

    return this.validPostcodes.includes(control.value)
      ? null
      : { customError: true };
  }

  private removeUrlRouteName(): void {
    const currentUrl = this.location.path();
    const updatedUrl = currentUrl.replace("/affiliates", "");

    this.location.replaceState(updatedUrl);
  }

  private getGenderAndDate(value): void {
    if (!value) return;

    let date = moment(value.substring(0, 6), "YYMMDD");
    let lastChar = value.substring(11);
    let gender = lastChar % 2 ? "M" : "F";

    if (moment().isBefore(date)) {
      date.subtract(100, "year");
    }

    this.custFormGroup.patchValue({
      dob: date.toDate(),
      gender: gender
    });
  }

  private setNonCompanyValidation(): void {
    ["dob", "gender", "maritalStatus"].forEach((key) => {
      this.custFormGroup.get(key).setValidators(Validators.required);
      this.custFormGroup.get(key).updateValueAndValidity();
    });
  }

  private setCompanyValidation(): void {
    ["dob", "gender", "maritalStatus", "nationality"].forEach((key) => {
      this.custFormGroup.get(key).clearValidators();
      this.custFormGroup.get(key).updateValueAndValidity();
    });

    this.custFormGroup.get("tINNo").setValidators(Validators.required);
    this.custFormGroup.get("tINNo").updateValueAndValidity();
  }

  private getCountryList() {
    if (this.countryList.length != 0) {
      this.filterCountry();
      return;
    }

    this.masterDataDataService.getCountrySelection().subscribe({
      next: (x) => {
        const exclude = [
          "Iran",
          "Syria",
          "North Korea",
          "Sudan",
          "Crimea",
          "Venezuela",
          "Cuba",
          "Israel",
          "Russian Federation",
          "Ukraine"
        ];
        this.countryList = x.filter((country) => !exclude.includes(country));
        this.filterCountry();
      },
      error: (err) => {
        this.alertService.openSnackBar(err.error);
      }
    });
  }

  getIdentityNoLabel(): string {
    let identityLabel: string;

    if (this.isMalaysian && !this.isCompany) {
      if (this.vehicleFormGroup.controls.vehicleType.value === "Lorry") {
        identityLabel = "common.icNoLabelLorry";
      } else {
        identityLabel = "common.icNoLabel";
      }
    } else if (!this.isMalaysian) {
      identityLabel = "common.passportLabel";
    } else {
      identityLabel = "common.businessRegistrationNoLabel";
    }

    return identityLabel;
  }

  getNameLabel(): string {
    let nameLabel: string;

    if (this.isMalaysian && !this.isCompany) {
      nameLabel = "common.namePerIc";
    } else if (!this.isMalaysian) {
      nameLabel = "common.namePerPassport";
    } else {
      nameLabel = "common.companyName";
    }

    return nameLabel;
  }

  getIdentityNoMasking(): string {
    if (this.isMalaysian && !this.isCompany) return "000000000000";
    return "";
  }

  filterCountry(val: string = null): void {
    if (val) {
      let txt = val.trim().toLowerCase();
      this.filterCountryList = this.countryList.filter((x) =>
        x.trim().toLowerCase().startsWith(txt)
      );
    } else {
      this.filterCountryList = Object.assign([], this.countryList);
    }
  }

  async submit(): Promise<void> {
    window.scrollTo(0, 0);

    if (this.vehicleFormGroup.invalid || this.custFormGroup.invalid) return;

    let vehicleForm = this.vehicleFormGroup.getRawValue();
    let custForm = this.custFormGroup.getRawValue();

    this.successGifType = custForm.contactMethod;
    custForm.contactMethod == "Mobile"
      ? (this.contactInfo = custForm.mobileNo)
      : (this.contactInfo = custForm.email);

    let contactMethod =
      custForm.contactMethod == "Mobile"
        ? "Mobile (Whatsapp)"
        : custForm.contactMethod;

    let isCommercialInd = false;
    let isCommercialCom = false;
    if (this.isLorry) {
      // Company (3) or Commercial (Company) (5) is a company, anything else is an individual
      if (custForm.idType === 3 || custForm.idType === 5) {
        isCommercialCom = true;
      } else {
        isCommercialInd = true;
      }
    } else {
      if (custForm.idType === 4) {
        isCommercialInd = true;
      } else if (custForm.idType === 5) {
        isCommercialCom = true;
      }
    }

    let input: MotorQuotationInterface = {
      insuranceType: vehicleForm.insuranceType,
      vehicleNo: vehicleForm.carPlate,
      vehicleType: vehicleForm.vehicleType,
      typeofSum: vehicleForm.insuredType,
      includeRoadTax:
        this.partnerCode == "lalamove"
          ? vehicleForm.eHailingUsed == true
            ? false
            : vehicleForm.eHailingUsed == false
            ? true
            : false
          : vehicleForm.includeRoadTax,
      eHailingUsed: vehicleForm.eHailingUsed,
      // this.partnerCode == "grab"
      //   ? vehicleForm.typeOfDrive == "Regular"
      //     ? false
      //     : vehicleForm.typeOfDrive == "Ehailing"
      //     ? true
      //     : false
      //   : vehicleForm.eHailingUsed,
      isMalaysian: this.isMalaysian,
      isCompany: this.isCompany,
      identityNo: this.isMotorcycle
        ? vehicleForm.identityNo
        : custForm.identityNo,
      postcode: vehicleForm.postcode,
      policIdentityNo: custForm.policIdentityNo,
      preferredChannel: contactMethod,
      name: custForm.name,
      nationality: custForm.nationality,
      dob: custForm.dob,
      gender: custForm.gender,
      maritalStatus: custForm.maritalStatus,
      mobileNo: custForm.mobileNo,
      email: custForm.email,
      language: this.partnerCode == "prolindung" ? "bm" : this.translate.currentLang,
      utmSouce: this.utmSource,
      utmMedium: this.utmMedium,
      utmCampaign: this.utmCampaign,
      utmContent: this.utmContent,
      moneyMamaRef: this.mmRef,
      isRenewal: false,
      motorLinkId: null,
      ...(vehicleForm.mileagePlan
        ? { motorMileagePlanId: vehicleForm.mileagePlan }
        : {}),
      vehicleGrant: this.carGrant,
      isCommercialIndividual: isCommercialInd,
      isCommercialCompany: isCommercialCom,
      oldBizRegNo: custForm.oldBizRegNo,
      tINGovInd: custForm.tINGovInd,
      tINNo: custForm.tINNo,
      sSTRegNo: custForm.sSTRegNo,
      isReconVehicle: vehicleForm.isReconVehicle
    };

    let duplicateRequest: CheckDuplicateRequest = {
      vehicleNo: vehicleForm.carPlate,
      identityNo: this.isMotorcycle
        ? vehicleForm.identityNo
        : custForm.identityNo,
      email: custForm.email,
      mobileNo: custForm.mobileNo,
      postcode: vehicleForm.postcode,
      eHailingUsed: vehicleForm.eHailingUsed,
      preferredChannel: contactMethod
    };

    this.ngxSpinnerService.show();

    /* Handle for Grab Mini App */
    if (this.isGrabMiniApp) {
      try {
        await this.containerModule.sendAnalyticsEvent({
          state: ContainerAnalyticsEventState.HOMEPAGE,
          name: "INITIATE"
        });
      } catch (err) {
        console.error('Analytics failed:', err);
      }
    }

    const isDuplicateQuote = await this.checkDuplicateQuote(duplicateRequest);
    if (isDuplicateQuote) return;

    let form: any = new FormData();
    for (const [key, value] of Object.entries(input) as [string, any][]) {
      if (value === null || value === undefined || value === "") continue;

      if (key === "dob") {
        form.append(key, CommonFunction.toCalendarDateUtc(value));
      } else {
        form.append(key, value);
      }
    }

    if (
      this.noIQAffiliates ||
      input.typeofSum === this.typeOfSumOption.agreedValue ||
      this.isLorry ||
      this.isMotorcycle
    ) {
      this.quotationSubmitted = false;
      this.ngxSpinnerService.show();

      /*
        [06/12/2024] - Temporary solution applied to handle client side (Carsome) submission issue
        If got vehicleGrant call submitRequest API with FromForm else call submit API with FromBody
      */
      this.motorQuotationDataService.submitRequest(form).subscribe({
        next: (x: SubmitQuotationResponseInterface) => {
          this.ngxSpinnerService.hide();

          if (x.isSuccess) {
            if (!x.isQuotationTooEarly) {
              if (input.typeofSum === this.typeOfSumOption.agreedValue) {
                this.handleSuccessSubmitAVQuotation(x.redirect_url);
              } else {
                this.handleSuccessSubmitQuotation(x.ncdExpDate, input, x.redirect_url);
              }
            }
            else {
              const dialogRef = this.dialog.open(
                BeforeExpiredDialogComponent,
                {
                  panelClass: "",
                  data: { expiryDate: x.ncdExpDate }
                });

              dialogRef.afterClosed().subscribe((x) => {
                this.backToHome("");
              });
            }
          }
          else {
              const dialogRef = this.dialog.open(
                SubmitFailDialogComponent,
                {
                  data: {
                    isAffiliate: true,
                    partnerCode: this.partnerCode,
                    isWithEHailing: x.isEhailing,
                    isTpftVehicleOverage: false,
                    insuranceType: x.insuranceType,
                    isVehicleUnderAged: x.isVehicleUnderAged,
                    isVehicleOverAged: x.isVehicleOverAged
                  },
                  panelClass: "fail-dialog"
              });

              dialogRef.afterClosed().subscribe(() => {
                this.resetForm();
                this.backToHome("");
              });
          }
        },
        error: (err) => {
          this.ngxSpinnerService.hide();
          this.alertService.openSnackBar("Please contact policy street.");
        }
      });
    } else {
      this.quotationSubmitted = true;
    }

    this.quotationInputData = input;
    this.quotationFormData = form;
  }

  // NOTE: Bypass Duplicate Request Check for KTMB
  async checkDuplicateQuote(request: CheckDuplicateRequest): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.motorQuotationDataService.checkDuplicateRequest(request).subscribe({
        next: (x: CheckDuplicateResponse) => {
          this.ngxSpinnerService.hide();

          const isExist = x.isExist === "Y" && this.partnerCode !== "ktmb";
          const isLinkExist = x.isLinkExist === "Y";

          if (isExist || isLinkExist) {
            this.dialog.open(RequestStatusDialogComponent, {
              panelClass: "no-padding-border-radius-dialog",
              data: {
                vehicleNo: request.vehicleNo,
                email: request.email,
                type: isExist ? "Dup_Quote" : "Dup_Active_Link"
              }
            });
            resolve(true);
          }

          resolve(false);
        },
        error: (_error: any) => {
          this.ngxSpinnerService.hide();
          resolve(true);
        }
      });
    });
  }

  async handleFileInput(e: any): Promise<void> {
    const files = (e.target as HTMLInputElement).files;
    const fileType = (e.target as HTMLInputElement).name;

    if (files.length === 0) return;

    for (let file of Array.from(files)) {
      const isUploadedFilesValid = await this.fileService.isUploadedFilesValid({
        file: file,
        files: files,
        currLength: this.fileList.length,
        maxLength: this.maxLength,
        accept: this.acceptFile,
        name: fileType,
        size: this.fileSize
      });

      if (!isUploadedFilesValid) {
        e.target.value = null;
        return;
      }

      this[fileType] = file;
    }

    e.target.value = null;
  }

  deleteFile(): void {
    this.carGrant = null;
  }

  whatsppRedirect(): void {

    if (this.partnerCode === "prolindung") {
      const whatsappNumber = 60123975965;
      const entityName = "Prolindung";
      let whatsappContent = "";
      let lang = this.translate.currentLang == "en" ? "en" : "ms";
      whatsappContent =
        lang == "ms"
          ? `Hai ${entityName}, saya ingin tahu dengan lebih lanjut mengenai cukai jalan dan takaful kenderaan`
          : `Hi ${entityName}, I would like to know more about road tax and car insurance`;

      let url = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(
        whatsappContent
      )}&source=&data=&app_absent=&lang=${lang}`;

      window.open(url, "_blank");
    }
    else {
      const whatsappNumber = 60182822320;
      const entityName = "Policystreet";
      let whatsappContent = "";
      let lang = this.translate.currentLang == "en" ? "en" : "ms";
      whatsappContent =
        lang == "ms"
          ? `Hai ${entityName}, saya ingin tahu dengan lebih lanjut mengenai cukai jalan dan insurans kenderaan`
          : `Hi ${entityName}, I would like to know more about road tax and car insurance`;

      let url = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(
        whatsappContent
      )}&source=&data=&app_absent=&lang=${lang}`;

      window.open(url, "_blank");
    }
  }

  countLoadedBanners(): void {
    this.loadedBanners++;

    if (this.loadedBanners > 1) {
      this.swiper.swiperRef.setGrabCursor();
    }
  }

  countLoadedEhailingBanners(): void {
    this.loadedEhailingBanners++;

    if (this.loadedEhailingBanners > 1) {
      this.swiper.swiperRef.setGrabCursor();
    }
  }

  private fetchMasterData(): void {
    const obs$: Observable<any>[] = [this.selectAllPostcodes$()];

    if (
      this.showMileagePlans ||
      this.partnerDataService?.partnerDetail?.isMileageEnabled
    ) {
      obs$.push(this.getMotorMileagePlans$());
    }

    forkJoin(obs$).subscribe({
      error: (err) => {
        this.alertService.openSnackBar(err.error);
      }
    });
  }

  private selectAllPostcodes$(): Observable<string[]> {
    return this.masterDataDataService.selectAllPostcodes().pipe(
      tap((postcodes) => {
        this.validPostcodes = postcodes;
      })
    );
  }

  private getMotorMileagePlans$(): Observable<DropdownItem[]> {
    return this.masterDataDataService.getMotorMileagePlans().pipe(
      tap((mileagePlans) => {
        this.mileagePlans = mileagePlans;
      })
    );
  }

  private handleSuccessSubmitQuotation(
    expiryDate: string,
    customerInput: MotorQuotationInterface,
    redirectUrl: string
  ): void {
    const dialogRef = this.dialog.open(SubmitSuccessDialogComponent, {
      panelClass: "success-dialog",
      data: { expiryDate, customerInput, partnerCode: this.partnerCode }
    });
    dialogRef.afterClosed().subscribe(() => this.backToHome(redirectUrl));
  }

  private handleSuccessSubmitAVQuotation(redirectUrl: string) {
    const dialogRef = this.dialog.open(SubmitSuccessAvDialogComponent, {
      panelClass: "success-dialog"
    });
    dialogRef
      .afterClosed()
      .subscribe(() =>
        this.backToHome("/affiliates?partnerCode=" + this.partnerCode)
      );
  }

  openPdpaLink() {
    CommonFunction.partnerOpenExternalLink(this.partnerCode, this.isGrabMiniApp, this.partnerData?.partnerDetail?.pdpaLink);
  }

  backToHome(redirectUrl: string) {
    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      window.location.href = "/affiliates?partnerCode=" + this.partnerCode;
    }
  }

  private get noIQAffiliates(): boolean {
    const noIQAffiliatesList = ["grab", "ktmb", "foodpanda"];
    return noIQAffiliatesList.includes(this.partnerCode);
  }

  private resetForm(): void {
    this.pdpaAgreement = false;
    this.carGrant = null;
    this.vehicleFormGroup.reset();
    this.custFormGroup.reset();

    this.custFormGroup.controls.mobileNo.setValue(" ");
    this.custFormGroup.controls.mobileNo.updateValueAndValidity();
    this.initForm();
    this.listenChanges();
    this.stepper.reset();

    window.scrollTo(0, 0);
  }

  @HostListener("window:resize", [])
  onResize() {
    var width = window.innerWidth;
    this.mobileView = width < 960;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription && !subscription.closed) {
        subscription.unsubscribe();
      }
    });
  }
}

interface Banner {
  lang: string;
  src: string;
  show: boolean;
  alt: string;
}
